const OnboardingUserTables = {
  USER_META_TABLE: 'userMetaTable',
  COGNITO_USER: 'cognitoUser',
};

export default OnboardingUserTables;



// WEBPACK FOOTER //
// ./src/enum/user/OnboardingUserTables.js